import setLeftNavIrisState from './mutators/setLeftNavIrisState';
import { makeArcCall } from './service/makeArcCalls';

export default async function initializeLeftNavUpsellState() {
    let leftNavIrisDetails = await makeArcCall();
    if (leftNavIrisDetails) {
        setLeftNavIrisState(leftNavIrisDetails);
    }
}
